(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ck-commerce"] && !Shopify.designMode) return;
  try {
    const money = (amount,form) => new Intl.NumberFormat(document.documentElement.lang || 'nl',{style:'currency',currency:form.dataset.currency || 'EUR'}).format(amount/100);
  document.addEventListener('change',event=>{
    const form=event.target.closest('[data-kit-form]');
    if(!form)return;
    const item=event.target.closest('[data-kit-item]');
    if(event.target.matches('[data-kit-variant]')) {
      const option=event.target.selectedOptions[0];
      item.querySelector('[data-kit-price]').textContent=money(Number(option.dataset.price || 0),form);
      const include=item.querySelector('[data-kit-include]');
      if(include)include.checked=true;
    }
    const total=[...form.querySelectorAll('[data-kit-item]')].reduce((sum,row)=>{
      if(!row.querySelector('[data-kit-include]')?.checked)return sum;
      return sum+Number(row.querySelector('select').selectedOptions[0]?.dataset.price || 0);
    },0);
    const output=form.querySelector('[data-kit-total]');
    if(output)output.textContent=money(total,form);
  });
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-kit-form]');
    if(!form)return;
    event.preventDefault();
    if(form.dataset.loading==='true')return;
    const isMultiple=form.hasAttribute('data-kit-multiple');
    const rows=[...form.querySelectorAll('[data-kit-item]')].filter(row=>!isMultiple || row.querySelector('[data-kit-include]').checked);
    const status=form.querySelector('[data-kit-status]');
    if(!rows.length || rows.some(row=>!row.querySelector('select').value)) {
      status.textContent=form.dataset.required || form.dataset.error;
      rows.find(row=>!row.querySelector('select').value)?.querySelector('select').focus();return;
    }
    const items=rows.map(row=>({id:Number(row.querySelector('select').value),quantity:1}));
    const button=form.querySelector('[type=submit]');
    const label=button.textContent;
    form.dataset.loading='true';button.disabled=true;button.textContent=form.dataset.busy;status.textContent='';
    try {
      const { CartAddEvent } = await import('@theme/events');
      const sectionIds=[...new Set([...document.querySelectorAll('cart-items-component')].map(el=>el.dataset.sectionId).filter(Boolean))].slice(0,5);
      const response=await fetch(form.action+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:sectionIds,sections_url:window.location.pathname})});
      const data=await response.json();
      if(!response.ok)throw new Error(data.description || form.dataset.error);
      status.textContent=form.dataset.success;
      let itemCount=Number(document.querySelector('cart-icon')?.currentCartCount || 0)+items.reduce((n,item)=>n+item.quantity,0);
      let cartResource=data;
      try {
        const cartUrl=new URL(form.action);cartUrl.pathname=cartUrl.pathname.replace(/\/cart\/add$/, '/cart.js');
        const cartResponse=await fetch(cartUrl,{headers:{Accept:'application/json'}});
        if(cartResponse.ok){cartResource=await cartResponse.json();itemCount=cartResource.item_count;}
      } catch(error) {}
      document.dispatchEvent(new CartAddEvent(cartResource,'classick-kit',{source:'classick-kit',itemCount,sections:data.sections}));
      document.querySelector('cart-drawer-component')?.open();
      if(isMultiple) {
        form.reset();
        const output=form.querySelector('[data-kit-total]');if(output)output.textContent=money(0,form);
      }
    } catch(error) {status.textContent=error.message || form.dataset.error;}
    finally {form.dataset.loading='false';button.disabled=false;button.textContent=label;}
  });
  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      entry.target.animate([{opacity:.35,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:550,easing:'cubic-bezier(.2,.7,.2,1)'});
      observer.unobserve(entry.target);
    }),{threshold:.12});
    document.querySelectorAll('.ck-kit__content,.ck-rider,.ck-cats__card').forEach(el=>observer.observe(el));
  }
  } catch(e) { console.error(e); }
})();

})();
